import _ from "lodash";
import moment from "moment";

export const isFutureDate = (date) =>
  moment(date).isAfter(moment().endOf("day"));

export function todo(contacts) {
  return [
    {
      title: "A fazer",
      items: _.orderBy(
        contacts.filter(
          (contact) =>
            contact?.status == "open" ||
            (contact?.status == "snoozed" &&
              !isFutureDate(contact.last_activity.date))
        ),
        ["last_message.created_at"],
        ["desc"]
      ),
    },
  ];
}

export function activities(contacts) {
  return [
    {
      title: "Futuras",
      items: _.orderBy(
        contacts.filter(
          (contact) =>
            (contact?.status == "open" || contact?.status == "snoozed") &&
            contact.last_activity &&
            isFutureDate(contact.last_activity.date) &&
            contact.last_activity.activity_type == "feedback_customer"
        ),
        ["last_activity.date"],
        ["asc"]
      ),
    },
  ];
}

export function visits(contacts) {
  const future = _.orderBy(
    contacts.filter(
      (contact) =>
        (contact?.status == "open" || contact?.status == "snoozed") &&
        contact.last_activity &&
        isFutureDate(contact.last_activity.date) &&
        contact.last_activity.activity_type == "scheduled_visit"
    ),
    ["last_activity.date"],
    ["asc"]
  );

  const late = _.orderBy(
    contacts.filter(
      (contact) =>
        (contact?.status == "open" || contact?.status == "snoozed") &&
        contact.last_activity &&
        !isFutureDate(contact.last_activity.date) &&
        contact.last_activity.activity_type == "scheduled_visit"
    ),
    ["last_activity.date"],
    ["desc"]
  );

  switch (true) {
    case future.length === 0 && late.length === 0:
      return [{ title: "Sem visitas agendadas", items: [] }];
    case future.length > 0 && late.length === 0:
      return [{ title: "Futuras", items: future }];
    case future.length === 0 && late.length > 0:
      return [{ title: "Atrasadas", items: late }];
    case future.length > 0 && late.length > 0:
      return [
        {
          title: "Futuras",
          items: future,
        },
        {
          title: "Atrasadas",
          items: late,
        },
      ];
  }
}

export function favorites(contacts) {
  return [
    {
      title: "Favoritos",
      items: _.orderBy(
        contacts.filter(
          (c) => c?.is_favorite && ["open", "snoozed"].includes(c?.status)
        ),
        ["last_message.created_at"],
        ["desc"]
      ),
    },
  ];
}

export function all(contacts) {
  return [
    {
      title: "Todos",
      items: _.orderBy(contacts, ["last_message.created_at"], ["desc"]),
    },
  ];
}
